import React, { FC } from 'react';
import { Spinner } from '@resideo/blueprint-react';
import { LoadingContainer } from './PageLoading.style';

const PageLoading: FC = () => {
  return (
    <LoadingContainer>
      <Spinner color='primary' size='xxLarge' />
    </LoadingContainer>
  );
};

export default PageLoading;
